const clientConfig = {
	siteUrl: 'https://searchhealer.com/pdconsultants'
};

export default clientConfig;